// Selectable accent themes (applied at runtime via CSS variables)
export const ACCENT_THEMES = [
  { key: "charcoal", label: "Charcoal Blue", primary: "219 14% 28%", primaryFg: "0 0% 100%" },
  { key: "sage", label: "Sage", primary: "150 20% 40%", primaryFg: "0 0% 100%" },
  { key: "clay", label: "Clay", primary: "18 42% 50%", primaryFg: "0 0% 100%" },
  { key: "sand", label: "Warm Sand", primary: "35 40% 46%", primaryFg: "0 0% 100%" },
  { key: "slate", label: "Slate", primary: "215 20% 42%", primaryFg: "0 0% 100%" },
  { key: "teal", label: "Teal", primary: "172 55% 38%", primaryFg: "0 0% 100%" },
  { key: "blue", label: "Blue", primary: "215 60% 52%", primaryFg: "0 0% 100%" },
  { key: "violet", label: "Violet", primary: "265 45% 55%", primaryFg: "0 0% 100%" },
  { key: "rose", label: "Rose", primary: "345 55% 55%", primaryFg: "0 0% 100%" },
];

export function applyAccent(key) {
  const t = ACCENT_THEMES.find((a) => a.key === key) || ACCENT_THEMES[0];
  const root = document.documentElement;
  root.style.setProperty("--primary", t.primary);
  root.style.setProperty("--primary-foreground", t.primaryFg);
  root.style.setProperty("--ring", t.primary);
}
